import { ProfilePageTabId } from '@colonist/clientforge';
import { UIWProfileController } from '../../../profile/UIWProfileController.ts';
import { ClientUserState } from '../../../../../shared/scripts/ClientUserState.ts';
export class UIDProfileSceneController {
    hide() {
        this.profileSceneContainerDiv.classList.add('hidden');
    }
    show() {
        this.profileSceneContainerDiv.classList.remove('hidden');
        this.sidebarController.deactivateAllButtons();
    }
    async updatePageContent(username) {
        var _ClientUserState_userState;
        const profileController = this.profileController;
        profileController.username = username;
        profileController.profileLinkController.resetApiCalls();
        profileController.profileLinkController.showSection(ProfilePageTabId.Overview);
        await profileController.getStickyPlayerInfo();
        profileController.friendsController.setUsername(username);
        const userIsMe = ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.username) === username;
        profileController.friendsController.profileIsCurrentUser = userIsMe;
        await profileController.friendsController.createDropdown();
        if (userIsMe) {
            profileController.settingsController.showSettingsTab();
            profileController.friendsController.showFriendsTab();
        } else {
            profileController.friendsController.hideFriendsTab();
            profileController.settingsController.hideSettingsTab();
        }
        await profileController.makeApiCall();
    }
    constructor(sidebarController){
        this.sidebarController = sidebarController;
        this.profileController = new UIWProfileController();
        this.profileSceneContainerDiv = document.getElementById('scene_discord_profile_container');
    }
}
